import React from 'react'
import styles from './Label.less'
import { GridCell } from './GridCell'
import { Grid } from './Grid'

export function Label (props) {
  const { text = '' } = props
  return <Grid paddingX marginX>
    <GridCell medium={12} >
      <div className= {styles.LabelControl}>
        <p>{text}</p>
      </div>
    </GridCell>
  </Grid>
}
